const EN_US = {
    common: {
        save: 'Save',
        okay: 'Okay',
        email: 'Email',
        search: 'Search',
        clear: 'Clear',
        download: 'Download',
        edit: 'Edit',
        cancel: 'Cancel',
        delete: 'Delete',
        addNew: 'Add New',
        true: 'true',
        false: 'false',
        select: 'Select',
        actions: 'Actions',
        deletePrompt: 'Are you sure you wish to delete?',
        close: 'Close',
        error: 'Error',
        pay: 'Pay',
        print: 'Print',
        cost: 'Cost',
        or: 'OR',
        success: 'Success',
        date: 'Date',
        previous: 'Previous',
        next: 'Next',
        first: 'First',
        last: 'Last',
        city: 'City',
        state: 'State',
        submit: 'Submit',
        confirm: 'Confirm',
        update: 'Update',
        reset: 'Reset',
        accountNumber: 'Account Number',
        payment: 'Payment',
        customer: 'Customer',
        requiredFieldDescription: '* Field is required',
        permitExpirationTypes: {
            ANN: 'Annual',
            DAT: 'Specific Date',
            NOE: 'No Expiration',
            M: 'Monthly',
            D: 'Daily',
            Q: 'Quarterly',
            MS: 'Month Start'
        },
        customerEdit: {
            recIDLabel: 'Account Number',
            firstNameLabel: 'First Name',
            lastNameLabel: 'Last Name',
            address1Label: 'Address 1',
            address2Label: 'Address 2',
            cityLabel: 'City',
            stateLabel: 'State',
            zipLabel: 'Zip',
            phoneNumberLabel: 'Phone Number',
            emailAddressLabel: 'Email Address',
        }
    },
    shared: {
        enumSelector: {
            defaultPlaceholder: 'Please select',
        },
        dropdown: {
            unsetLabel: '<clear selection>',
        },
        keyValuePairGrid: {
            key: 'key',
            value: 'value',
            copyValues: 'Copy Values'
        }
    },
    notes: {
        editor: {
            add: 'Add Note',
            note: 'Note'
        }
    },
    locationRoot: {
        menus: {
            'CITATION SEARCH': 'CITATION SEARCH'
        },
    },
    locationHome: {
        jumbotron: {
            message: 'Site in progress, most pages not yet updated, but more to come soon!',
            header: 'Welcome to VATS',
            lead: 'VATS 2.0 UI Refresh'
        }
    },
    permits: {
        common: {
            permitID: 'Permit ID',
            permitType: 'Permit Type',
            plateState: 'Plate State',
            plateNumber: 'Plate Number',
            vehiclePlate: 'Vehicle Plate',
            plateType: 'Plate Type',
            vehicleMake: 'Vehicle Make',
            vehicleColor: 'Vehicle Color',
            vehicleType: 'Vehicle Type',
            vehicleYear: 'Vehicle Year',
        },
        typeSelect: {
            startDate: 'Start Date',
            expirationType: 'Expiration Type',
            duration: 'Duration',
            expirationDate: 'Expiration Date',
            enableOverrides: 'Enable Overrides',
            typeLoadError: 'Error Loading Permit Type',
            category: 'Category',
            categoryPlaceholder: 'Select Category'
        },
        permitCreate: {
            permitApplicationTitle: 'Apply for Permit',
            documentUploadPlaceholder: 'Upload documents',
            permit: 'Permit',
            vehicle: 'Vehicle',
            documentUploads: 'Proof of Employment',
            documentUploadDropPlaceholder: 'Drop documents here',
            termsAndConditions: 'Terms and Conditions',
            customer: 'Customer',
            businessCustomer: 'Business Customer',
            documents: 'Documents',
            instructions: 'Instructions',
            addSharedVehicles: 'Add Shared Vehicles',
            nNumber: 'N-Number',
            number: 'Number',
            applicationError: 'There was an error with your permit application. Check the fields outlined in red.',
            dateError: 'There was an error with your permit application. Please check the dates selected.',
            customerCreateError: 'There was an error creating the new customer',
            addNoteError: 'There was an error adding the customer note',
            permitsUnavailable: 'There are no available permits of this type remaining',
            uploadError: 'Error uploading documents. No Documents uploaded.',
            customerUpdateError: 'Error updating customer. Customer not updated.',
            downloadError: 'Error downloading documents. No Documents downloaded.',
            documentRetrievalError: 'Error retrieving documents.',
            licenseUpload: 'Copy of your current driver\'s license',
            licenseUploadDropPlaceholder: 'Drop license here',
            licenseUploadPlaceholder: 'Upload license',
            vehicleRegistrationUpload: 'Copy of your current vehicle registration',
            vehicleRegistrationUploadDropPlaceholder: 'Drop vehicle registration here',
            vehicleRegistrationUploadPlaceholder: 'Upload vehicle registration'
        },
        permitSearch: {
            permitIDPlaceholder: 'Permit ID',
            customerName: 'Customer Name',
            vehiclePlate: 'Vehicle Plate',
            plateState: 'Plate State',
            status: 'Status',
            pay: 'Pay',
            renew: 'Renew',
            vehicleLicensePlaceholder: 'Vehicle License',
            notFound: 'Permit not found'
        }
    },
    payment: {
        selectLocationPlaceholder: 'Select a location',
        unknownLocationMessage: 'Location \'{location}\' is unknown or not available',
        error: {
            errorMessage: 'An error occurred and we were unable to complete your payment.',
            noChargeAssurance: 'Your card has not been charged.',
            instructions: 'Please try again or contact support.',
        },
        citationPayment: {
            loadFailedTitle: 'Search Failed',
            loadFailedMessage: 'Citation search failed.  Please try again or contact support.',
            citationSearchPlaceholder: 'Enter a citation number',
            citationIdHeader: 'Citation',
            vehicleLicenseHeader: 'License #',
            vehicleStateHeader: 'State',
            owedHeader: 'Owed',
            payLabel: 'Pay?',
            noCitationsFound: 'No citations found',
            citationPaymentHeader: 'Citation Payment',
            totalLabel: 'Total:',
            paymentFailedTitle: 'Payment Failed',
            paymentFailedMessage: 'We were unable to process your payment.  Please try again.',
            subtotalLabel: 'Subtotal:',
            feeLabel: 'Fee',
            taxLabel: 'Tax',
            discountLabel: 'A discount of {discount} is being applied to this citation',
            redirectingTitle: 'Redirecting...',
            redirectingMessage: 'Please wait while we redirect you',
            mustPayText: 'Citations {highlight} must be paid',
            mustPayHighlightText: 'highlit in red',
            nothingSelectedToPayMessage: 'Please select at least one citation to pay.',
            plateSearchPlaceholder: 'Plate number',
            stateSearchPlaceholder: 'Select State',
            searchTermsRequiredMessage: 'Please enter a citation number or vehicle plate/state to search',
            searchByOnlyOneMessage: 'Please enter only a citation number or vehicle plate/state, not both',
            pleaseSelectStateMessage: 'Please select the vehicle\'s state',
            pleaseEnterPlateMessage: 'Please enter the vehicle\'s plate number',
            additionalCitationMessage: 'Highlighted rows are possible additional customer owned vehicles',
            citationIdNotFoundMessage: 'Citation \'{citation}\' was not found',
            vehicleNotFoundMessage: 'Plate {plateNumber} has no active citations',
            genericNotFoundMessage: 'No results found.',
            citationAlreadyPaidMessage: 'Citation \'{citation}\' has already been paid',
            citationAlreadyVoidedMessage: 'Citation \'{citation}\' has been voided and does not need to be paid',
            userCannotAcceptPaymentsMessage: 'Your user account is not authorized to accept payments',
            requiredCitationsNotSelectedMessage: 'You must pay all marked citations',
            bootRelease: {
                request: {
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load details about your boot',
                    beginSelfReleaseLabel: 'Enter card details for account hold: ',
                    beginSelfReleaseButtonText: 'Begin',
                    holdPreviouslyCompleted: 'Succesful hold previously completed. Release codes below: ',
                    beginReleaseWithFive9ButtonText: 'Begin Release with Five9',
                    releaseCodeLabel: 'Release code(s): ',
                    manualReleaseCodeTitle: 'Manually retrieve release codes',
                    showSelfReleaseCodeButtonText: 'Show code(s)',
                    bootReleaseTitle: 'Boot Release',
                    releaseCodeLoadFailedTitle: 'Unable to load release codes',
                    releaseCodeLoadFailedMessage: 'An unexpected error occured and we are unable to display your release codes',
                    holdRequestFailedTitle: 'Request Failed',
                    holdRequestFailedMessage: 'Unable to request credit hold',
                },
                completion: {
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load details about your release request',
                    messageLoadFailedTitle: 'Load failed',
                    messageLoadFailedMessage: 'Unable to display release instructions',
                    releaseCodeLoadFailedTitle: 'Unable to load release codes',
                    releaseCodeLoadFailedMessage: 'An unexpected error occured and we are unable to display your release codes',
                    emailSuccessfulTitle: 'Email sent',
                    emailSuccessfulMessage: 'Successfully emailed',
                    emailFailedTitle: 'Email failed',
                    emailFailedMessage: 'Unable to send email',
                    success: 'A hold was successfully applied.',
                    releaseCodeLabel: 'Here is your release code:',
                    emailCodeLabel: 'Enter your address to have your release code(s) and credit hold receipt emailed to you',
                    sendReleaseCodesButtonText: 'Send Email',
                    downloadReceiptText: 'Download Receipt',
                    holdFailed: 'Unable to complete the hold on your account.  Message from the card processor: {processorResponse}',
                    notCompleted: 'The process of placing the hold has not yet been completed',
                },
            },
            error: {
                errorMessage: 'An error occurred and we were unable to complete your payment.',
                noChargeAssurance: 'Your card has not been charged.',
                instructions: 'Please try again or contact support.',
            },
            completion: {
                loadFailedMessage: 'We were unable to load your payment information.  Please try again.',
                loadFailedTitle: 'Error',
            }
        },
        permitPayment: {
            noPaymentPending: 'There is no payment pending on this permit.',
            awaitingApproval: 'This permit is awaiting approval.',
            alreadyActive: 'This permit is already active.',
            loadFailedTitle: 'Search Failed',
            loadFailedMessage: 'Permit search failed.  Please try again or contact support.',
            permitSearchPlaceholder: 'Enter a permit number',
            permitIdHeader: 'Permit',
            billingCustomer: 'Billing Customer',
            vehicleLicenseHeader: 'License #',
            vehicleStateHeader: 'State',
            owedHeader: 'Owed',
            noPermitsFound: 'No permits found',
            totalLabel: 'Total:',
            paymentFailedTitle: 'Payment Failed',
            paymentFailedMessage: 'We were unable to process your payment.  Please try again.',
            subtotalLabel: 'Subtotal:',
            feeLabel: 'Fee',
            discountLabel: 'A discount of {discount} is being applied to each permit',
            redirectingTitle: 'Redirecting...',
            redirectingMessage: 'Please wait while we redirect you',
            findExisting: 'Pay for Existing',
            selectLocation: 'Select Location',
            createNew: 'Create New',
            applyNew: 'Apply for New',
            renew: 'Renew',
            permitPaymentTitle: 'Permit Payment',
            successfulApplicationSubmission: 'Application submission successful',
            permitNotFound: 'Permit not found',
            successfulApplicationApprovalPending: 'Permit application succesfully submitted. You will be notified once it has been approved.'
        },
        paymentCompletion: {
            successMessage: 'Payment successful',
            emailAddressLabel: 'Email: ',
            sendReceiptButtonText: 'Email Receipt',
            emailSuccessfulTitle: 'Email sent',
            emailSuccessfulMessage: 'An email with the receipt attached has been sent to {address}',
            emailFailedTitle: 'An error occurred',
            emailFailedMessage: 'An error prevented your email from being sent',
            downloadReceiptText: 'Download Receipt',
            loadFailedTitle: 'Load failed',
            loadFailedMessage: 'Unable to load the payment completion data',
            vantiv: {
                paymentCompletionFailedTitle: 'Unable to complete payment',
                paymentCompletionFailedMessage: 'We were unable to complete your payment.  Please try again or contact support.',
                unableToContactPaymentProcessorTitle: 'Error',
                unableToContactPaymentProcessorMessage: 'We were unable to contact our payment processor.  Please try again later or contact support.',
                invalidCard: {
                    mod10: 'Invalid card number.  You may have a typo.',
                    tooShort: 'The entered card number was too short.',
                    tooLong: 'The entered card number was too long.',
                    notANumber: 'The entered card # is not a number.',
                    technicalDifficulties: 'Internal error validating card.  Please try again or contact support',
                    failureFromServer: 'Card number rejected.  Please confirm the number and try again.',
                    cvv: {
                        notANumber: 'Entered CVV is not a number.',
                        tooShort: 'Entered CVV is too short.',
                        tooLong: 'Entered CVV is too long.',
                    }
                }
            }
        },
        five9Payment: {
            payWithFive9: 'Pay with Five9'
        },
        paypalCompletion: {
            waitMessage: 'Please wait while the card is processed',
            errorMessage: 'An error occurred and we were unable to process your payment.  Please contact support.',
        },
        paymentMethods: {
            unknownMethodLabel: '{method} is not known or implemented as a payment method',
        },
        checkPayment: {
            checkNumberLabel: 'Check Number',
            postmarkDateLabel: 'Postmark Date',
        },
        moneyOrderPayment: {
            checkNumberLabel: 'Check Number',
            postmarkDateLabel: 'Postmark Date',
        },
        cardPayment: {
            creditCardNumberLabel: 'Credit Card Number',
            cvvLabel: 'CVV',
            cvvDescription: '(3 digits on back of card)',
            expirationMonthLabel: 'Expiration Month',
            expirationYearLabel: 'Expiration Year',
        },
    },
    appeals: {
            escalation: 'Escalation',
            previousVoid: 'Previous Voids',
            totalCitations: 'Total Citations',
            brokenMeter: 'Broken Meter Record found within 30 days of Citation Issuance Date.  Meter reported broken with an issue of',
            saveSuccessMessage: 'Changes successfully saved.',
            citationAppeal: {
                linkName: 'Citation Appeal',
                enterCitationId: 'Enter Citation ID',
                loadFailedTitle: 'Search Failed',
                loadFailedMessage: 'Citation search failed. Please try again or contact support.',
                issuingAgent: 'Issuing Agent',
                issuingDate: 'Issue Date & Time'
            },
            showPhotos: {
                linkName: 'Show Photos',
                loadFailedTitle: '',
                loadFailedMessage: 'Please try again or contact support.',
                rotate: 'Rotate image',
                zoomIn: 'Zoom In',
                zoomOut: 'Zoom Out',
                moveToTop: 'Move To Top',
                confirmDeleteMessage: 'Really delete this photo?'
            },
            notes: {
                recordId: 'Record ID',
                enteredBy: 'Entered By',
                reason: 'Reason',
                noteReason: 'Note Reason',
                attachment: 'Attachment',
                view: 'View',
            },
            information: {
                appellant: {
                    linkName: 'Appellant Information',
                    copyInfo: 'Copy appellant info to customer contact info?',
                    appellantErrorMessage: 'Appellant information must include Name, Address, City, State, Zip'
                },
                customer: {
                    linkName: 'Customer Information',
                    copyInfo: 'Copy customer info to appellant contact info?'
                },
                noCitationMessage: 'Must enter Citation Number to proceed.'
            },
            appealInfo: {
                linkName: 'Appeal Info',
                dateAppealReceived: 'Date Appeal Received',
                appealReason: 'Appeal Reason',
                customerComment: 'Customer Comment',
                dateContacted: 'Date Contacted',
                citationAmt: 'Citation Amt',
                reviewBy: 'Review By',
                dateAdminReview: 'Date Admin Review',
                systemNotices: 'System Notices',
                systemNoticesSubtitle: '(Notes from VATS to Reviewer)',
                reviewerNotes: 'Reviewer Notes',
                reviewerNotesSubtitle: '(not displayed on letter)',
                resolutionNotes: 'Resolution Notes',
                resolutionNotesSubtitle: '(to be displayed on letter)',
                reviewDecision: 'Review Decision',
                updateAppeal: 'Update Appeal Information',
                viewNotes: 'View Notes',
                addNote: 'Add Note',
                errorNoReason: 'Must select an appeal reason to proceed.',
                warningVoid: ''
            },
            appealLetters: {
                linkName: 'Appeal Letters',
                letters: 'Letters',
                select: 'Select',
                letterDescription: 'Letter Description',
                printLetter: 'Print letter',
                emailLetter: 'Email letter'
            },
            hearingInfo: {
                linkName: 'Hearing Info',
                hearingDate: 'Hearing Date',
                hearingTime: 'Hearing Time',
                hearingOfficer: 'Hearing Officer',
                indefiniteHold: 'Indefinite Hold',
                cancelledHearing: 'Cancelled Hearing',
                decisionDate: 'Decision Date',
                resolutionNotes: 'Resolution Notes',
                resolutionNotesSubtitle: '(to be displayed on letter)',
                reviewDecision: 'Review Decision',
                updateHearingInfo: 'Update hearing information',
                cancelWarning: 'Cancel scheduled hearing?'
            },
            hearingLetters: {
                linkName: 'Hearing Letters',
                emailSuccessfulTitle: 'Email sent',
                appellantRequired: 'Email address cannot be blank.',
                selectAnOption: 'You must select an appeal letter to print'
            },
            previousAppeals: {
                linkName: 'Previous Citations/Appeals',
                citationnum: 'Citenum',
                platenum: 'Platenum',
                balance: 'Balance',
                void: 'Void',
                location: 'Location',
                block: 'Block',
                space: 'Space',
                violation: 'Violation',
                dateAppealed: 'Date Appealed',
                appealDecision: 'Appeal Decision',
                previousCitations: 'Previous Citations',
                previousAppeals: 'Previous Appeals'
            }
    },
    admin: {
        vatsTracking: {
            pageHeader: 'VATS Tracking'
        },
        chalkingLocationRules: {
            lotIdHeader: 'Lot',
            blockNumberHeader: 'Block',
            requireBlockNumberHeader: 'Require Block No.',
            requireSpaceNumberHeader: 'Require Space No.',
            requireValveStemPositionHeader: 'Require Valve Stem Pos.',

            deleteConfirmMessage: 'Really delete this rule?\n\n{lot}\n{block}',
            deleteConfirmTitle: 'Confirm Delete',
            deleteRuleError: 'Error deleting rule',
            refreshRulesError: 'Error refreshing rules'
        },
        customerAlias: {
            parentHeading: 'Customer Parent Alias',
            recidHeader: 'RecID',
            parentNameHeader: 'Parent Name',
            parentDescriptionHeader: 'Parent Description',
            parentAddressHeader: 'Parent Address',
            parentCityHeader: 'City',
            parentStateHeader: 'State',
            parentZipHeader: 'Zip',
            parentConfirmDeleteMessage: 'Really delete this parent record and its children?\n\nName: {name}\nDescription: {description}\nAddress: {address}\n{city} {state}, {zip}',
            childHeading: 'Customer Child Data',
            childLastNameHeader: 'Last Name',
            childFirstNameHeader: 'First Name',
            childMiddleNameHeader: 'Middle Name',
            childParentRecidHeader: 'Alias ID',
            childConfirmDeleteMessage: 'Really delete this child details record?\n\nLast Name: {lastName}\nFirst Name: {firstName}\nMiddle Name: {middleName}',
        },
        letterManagement: {
            heading: 'Letter/Reports Management',
            viewFormatted: 'View Formatted',
            viewHTML: 'View HTML',
            tinymceContent: 'initialContent',
            saveButtonMeesage: 'Save Content',
            letterSavedMessage: 'Letter data saved successfully',
            saveLetterError: 'Error saving letter data',
            refreshLetterError: 'Error retrieving letter data',
            confirmDeleteMessage: 'Really delete this letter?\n\nReport: {report}\nPeriod: {period}\nRecipients: {recipients}'
        },
        letterMatch: {
            heading: 'Letter Match Management',
            appealHeading: 'Appeal Decision/Letter Match',
            hearingHeading: 'Hearing Decision/Letter Match',
            descriptionColumn: 'Description',
            letterDescriptionColumn: 'Letter Description',
            appealFeeColumn: 'Appeal Fee',
            hearingFeeColumn: 'Hearing Fee',
            actions: 'Actions',
            refreshLetterError: 'Error retrieving letter match data',
            confirmDeleteMessage: 'Really delete this report?\n\nReport: {report}\nPeriod: {period}\nRecipients: {recipients}'
        },
        lotMaintenance: {
            lots: {
                linkName: 'Lots',
                heading: 'Active Lots:',
                locationID: 'Location ID',
                locationName: 'Location Name',
                zoneID: 'Zone ID',
                accountID: 'Account ID',
                routeID: 'Route ID',
                maxDailyFee: 'Max Daily Fee',
                syncWithHandheld: 'Sync With Handheld',
                deleteFailedTitle: 'Delete Failed',
                deleteFailedMessage: 'Error deleting lot lookup',
                saveFailedMessage: 'Unable to save lot lookup.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving lot lookup',
                violationProfile: 'Violation Profile',
            },
            lotViolationCodes: {
                linkName: 'Lot Violation Codes',
                heading: 'Location Violation Codes:',
                code: 'Code',
                description: 'Description',
                fineAmount: 'Fine Amount',
                deleteFailedTitle: 'Delete Failed',
                deleteFailedMessage: 'Error deleting lot violation code',
                saveFailedMessage: 'Unable to save lot violation code.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving lot violation code',
                violationProfile: 'Violation Profile',
            },
            violationCodes: {
                linkName: 'Violation Codes',
                heading: 'Violation Codes:',
                code: 'Code',
                description: 'Description',
                fineAmount: 'Fine Amount',
                escalationRate: 'Escalation Rate',
                escalationDays: 'Escalation Days',
                active: 'Active?',
                canEscalate: 'Can Escalate?',
                progressionGroup: 'Progression Group',
                progressionThreshold: 'Progression Threshold',
                resetProgressAfterDays: 'Reset Progress After Days',
                deleteFailedTitle: 'Delete Failed',
                deleteFailedMessage: 'Error deleting violation code',
                saveFailedMessage: 'Unable to save violation code.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving violation codes',
                violationBehaviorProfile: 'Behavior Profile',
                convertsToViolationCode: 'Converts To Violation Code',
                convertsAfterDays: 'Converts After Days',
            },
        },
        lotArea: {
            pageHeader: 'Lot Area Admin'
        },
        lprAnalysis: {
            pageHeader: 'LPR Analysis',
            filePlaceholder: 'Choose a file or drop it here...',
            fileDropPlaceholder: 'Drop file here...'
        },
        releaseNotes: {
            heading: 'Release Notes Management',
            noteDescriptionField: 'Note Description',
            noteDescriptionFieldPlaceholder: 'Description...',
            shortFormField: 'Short Form',
            longFormField: 'Long Form'
        },
        autoReportsMaintenance: {
            heading: 'Autoreports Management',
            report: 'Report',
            period: 'Period',
            recipients: 'Recipients',
            actions: 'Actions',
            confirmDeleteMessage: 'Really delete this report?\n\nReport: {report}\nPeriod: {period}\nRecipients: {recipients}'
        },
        reportManagement: {
            heading: 'Report Management',
            viewFormatted: 'View Formatted',
            viewHTML: 'View HTML',
            tinymceContent: 'Initial Content',
            saveButtonMeesage: 'Save Content',
            reportSavedMessage: 'Report data saved successfully',
            saveReportError: 'Error saving report data',
            refreshReportError: 'Error retrieving report data',
            confirmDeleteMessage: 'Really delete this report?\n\nReport: {report}'
        },
        handheldMessage: {
            messageLabel: 'Message',
            expirationDateLabel: 'Expiration Date',
            heading: 'Display Message to Handheld Device'
        },
        handheldUsers: {
            userID: 'User ID',
            password: 'Password',
            username: 'Username',
            isPEO: 'Is PEO',
            syncWithHandheld: 'Sync with Handheld',
            deleteConfirmMessage: 'Are you sure you want to delete user',
            deleteConfirmTitle: 'Confirm Delete',
            refreshUserError: 'Error retrieving handheld users',
            deleteUserError: 'Error deleting user'
        },
        meterMapping: {
            spaceColumnLabel: 'Space',
            locationColumnLabel: 'Location',
            blockColumnLabel: 'Block',
            violationColumnLabel: 'Violation',
            commentColumnLabel: 'Comment'
        },
        hearingBlackoutDates: {
            header: 'Hearing Dates',
            holidaysLabel: 'Holidays',
            blackoutDaysLabel: 'Blackout Dates',
            newBlackoutDayLabel: 'New Blackout Day',
            noBlackoutDays: 'No blackout days currently set',
            noDateError: 'Please select a date'
        },
        userManagement: {
            meOnlyLabel: 'Me Only',
            userID: 'User ID',
            username: 'Username',
            password: 'Password',
            email: 'Email',
            loginRole: 'Login Role',
            selectedDatabases: 'Selected Companies',
            userDatabase: 'Default Company',
            paymentAcceptance: 'Payment Acceptance',
            mustResetPassword: 'Reset Password',
            lockedOut: 'Locked Out',
            deleteConfirmMessage: 'Are you sure you want to delete user',
            deleteConfirmTitle: 'Confirm Delete',
            refreshUserError: 'Error retrieving user profiles',
            deleteUserError: 'Error deleting user',
            addUserError: 'Error adding user',
            editUserError: 'Error editing user'
        },
        notificationManagement: {
            heading: 'Notifications',
            filterExpired: 'Filter Expired Notifications',
            state: 'State',
            plate: 'Plate',
            startDate: 'Start Date',
            endDate: 'End Date',
            code: 'Code',
            noticeText: 'Notice Text',
        },
        bootManagement: {
            header: 'Boot Management',
            inventoryID: 'Inventory ID',
            releaseCode: 'Release Code',
            bootTypeID: 'Type',
            status: 'Status',
            deleteConfirmMessage: 'Are you sure you want to delete boot',
            deleteConfirmTitle: 'Confirm Delete',
            refreshBootError: 'Error retrieving boot profiles',
            deleteBootError: 'Error deleting boot',
            inventoryIDPlaceholder: 'Inventory ID',
            releaseCodePlaceholder: 'Release Code',
        },
        permitManagement: {
            permitCategories: {
                linkName: 'Categories',
                nameLabel: 'Name',
                codeLabel: 'Code',
                descriptionLabel: 'Description'
            },
            permitTypes: {
                linkName: 'Permit Management',
                heading: 'Permit Types',
                type: 'Type',
                cost: 'Cost Each',
                perHousehold: 'Per Household',
                category: 'Category',
                qtyAllowed: 'Qty Allowed Per Household',
                shared: 'Shared Permit?',
                shareQtyAllowed: 'Share Qty Allowed',
                expires: 'Expires?',
                permitExpire: 'Permit Expire',
                expirationPeriodType: 'Expiration Period Type',
                renewal: 'Renewal',
                autoGenRenewal: 'AutoGen Renewal Letter',
                allowAutoRenew: 'Allow AutoRenew',
                autoOnline: 'Allow Online Purchase',
                startDate: 'Permit Start',
                maxPermits: 'Max Permits Allowed Per Location',
                daysVisitor: 'Days Visitor Valid',
                applicationDocs: 'Permit Application Documents',
                startNumber: 'Permit Start Number',
                deleteConfirmMessage: 'Are you sure you want to delete permit type',
                deleteConfirmTitle: 'Confirm Delete',
                refreshPermitTypesError: 'Error retrieving permit types',
                deletePermitTypeError: 'Error deleting permit type',
                saveFailedMessage: 'Unable to save permit type.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving permit types'
            },
            permitSettings: {
                linkName: 'Permit Settings',
                heading: 'Permit Settings',
                letterStartDate: 'Start Date for permit expiration letters',
                letterNoticeDays: 'Generate letter xx days in advance of expiration',
                onlineRenewal: 'Allow online renewal only',
                transactionCharge: 'Web Payment Transaction Charge',
                useZonePrefix: 'Permit type uses Zone prefix?',
                allowAdvanceDays: 'Allow renewal xx days in advance of expiration',
                allowAfterDays: 'Allow renewal xx days after expiration',
                docsRequired: 'Renewal documents required',
                payAfterApproval: 'Customer pays after approval',
                citationsPaidRequired: 'Citations Paid in Full Required',
                notificationsAllowed: 'RenewalNotifications Allowed',
                setStartDate: 'Set annual start date to current date',
                customPermits: 'Custom permit numbers by type?',
                instructions: 'Instructions',
                terms: 'Terms and Conditions',
                email: 'Email address(s) to whom the notice of application and attachments will be sent',
                emailMsg: 'Use comma to separate multiple email addresses',
                emailTextMsg: 'Email Text (include any text that is pertinent to your location)',
                saveSettings: 'Save Permit Settings',
                deleteConfirmMessage: 'Are you sure you want to delete permit settings',
                deleteConfirmTitle: 'Confirm Delete',
                deletePermitTypeError: 'Error deleting permit type',
                saveSuccessMessage: 'Permit settings saved successfully.',
                saveSuccessTitle: 'Save Success',
                saveFailedMessage: 'Unable to save permit settings.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving permit settings',
                driverLicenseRequired: 'Driver license required',
                vehicleRegistrationRequired: 'Vehicle registration required',
            },
            applicationDocuments: {
                linkName: 'Permit Application Documents',
                heading: 'Permit Application Documents',
                docName: 'Document Name',
                description: 'Description',
                document: 'Document',
                startNumber: 'Permit Start Number',
                type: 'Type',
                prefix: 'Start Prefix',
                number: 'Start Number',
                saveNumber: 'Save Start Number',
                deleteConfirmTitle: 'Confirm Delete',
                deleteConfirmMessage: 'Are you sure you want to delete application document',
                deleteFailedTitle: 'Delete Failed',
                deleteFailedMessage: 'Error deleting application document',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save application ocuments.  Please try again or contact support.',
                loadFailedTitle: 'Load Error',
                loadFailedMessage: 'Error retrieving application documents',
                downloadMessage: 'Choose file or drop here...'
            },
        },
        bulkHoldRequest: {
            headingOne: 'Bulk Hold Request',
            headingTwo: 'Add Bulk Hold Request',
            citationsAfter: 'Citations After',
            holdPlacedDate: 'Hold Placed Date',
            holdReleaseDate: 'Hold Release Date',
            holdReason: 'Hold Reason',
            holdNewCitations: 'Hold New Citations',
            editButton: 'Edit',
            saveButton: 'Save',
            deleteConfirmMessage: 'Are you sure you want to delete permit settings',
            deleteConfirmTitle: 'Confirm Delete',
            deletePermitTypeError: 'Error deleting permit type',
            refreshSuccessMessage: 'Bulk hold released successfully.',
            refreshSuccessTitle: 'Release Success',
            saveSuccessMessage: 'Bulk hold saved successfully.',
            saveSuccessTitle: 'Save Success',
            saveFailedMessage: 'Unable to save bulk hold.  Please try again or contact support.',
            saveFailedTitle: 'Save Failed',
            loadFailedTitle: 'Load Error',
            loadFailedMessage: 'Error retrieving bulk holds',
        },
        reversalReasonManagement: {
            heading: 'Reversal Reason Management',
            code: 'Code',
            description: 'Description',
            reversalFee: 'Reversal Fee',
            saveSuccessMessage: 'Bulk hold saved successfully.',
            saveSuccessTitle: 'Save Success',
            saveFailedMessage: 'Unable to save bulk hold.  Please try again or contact support.',
            saveFailedTitle: 'Save Failed',
            confirmDeleteMessage: 'Are you sure you want to delete this reversal reason?',
            deleteConfirmTitle: 'Confirm Delete',
            deletePermitTypeError: 'Error deleting permit type',
            refreshSuccessMessage: 'Bulk hold released successfully.',
            refreshSuccessTitle: 'Release Success',
        },
        customerFileHistory: {
            heading: 'Customer File History',
            date: 'Date',
            fileType: 'File Type',
            viewEvents: 'View Customer Events',
            download: 'Download',
            loadFailedTitle: 'Load Failed',
            loadFailedMessage: 'Unable to load customer file history.  Please reload the page or contact support.',
            customerFileDetails: {
                linkName: 'Customer File Details',
                heading: 'Customer File Details',
                successful: 'Import or Export Successful',
                plate: 'Plate #',
                state: 'State',
                citation: 'Citation',
                details: 'Deatils',
                loadFailedMessage: 'Unable to load customer file details.  Please reload the page or contact support.',
            },
        },
        programVariables: {
            scofflaw: {
                linkName: 'Scofflaw',
                gracePeriodAfterNoticeLabel: 'Grace Period After Notice',
                minimumCitationsLabel: 'Minimum Citations',
                minimumDaysOldLabel: 'Minimum Days Old',
                maximumDaysOldLabel: 'Maximum Days Old',
                startDateLabel: 'Start Date',
                minimumAmountOwedLabel: 'Minimum Amount Owed',
                autoGenerateEmailLabel: 'Auto Generate Email',
                autoGeneratedEmailAddressLabel: 'Auto Generated Email Address',
                autoGenerateCitySyncFileLabel: 'Auto Generate City Sync File',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load scofflaw config settings.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save scofflaw config settings.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Scofflaw settings updated successfully.',
            },
            holds: {
                linkName: 'Holds',
                markForDMVRMVExportLabel: 'Mark For DMV/RMV Export',
                minAgeHoldCandidateLabel: 'Min Age Hold Candidate',
                dMVRMVFeeLabel: 'DMV/RMV Fee',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load holds settings. Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save holds settings. Please reload the page or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Holds settings updated successfully.',
            },
            booting: {
                linkName: 'Booting Config',
                maxBootFineLabel: 'Max Boot Fine',
                daysBeforeFineIncursLabel: 'Days Before Fine Incurs',
                dailyFineAmountLabel: 'Daily Fine Amount',
                bootViolationCodeLabel: 'Boot Violation Code',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Booting settings saved successfully',
                saveFailedMessage: 'Unable to save Booting settings.  Please try again or contact support.',
                saveFailedTitle: 'Save Failed',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load Booting settings.  Please reload the page or contact support.',
            },
            letters: {
                linkName: 'Letters',
                eligibleFor1stNoticeLabel: 'Eligible for 1st notice:',
                notice1StartDateLabel: 'Notice 1 Start Date',
                eligibleFor2ndNoticeLabel: 'Eligible for 2nd notice (days after 1st notice):',
                notice2StartDateLabel: 'Notice 2 Start Date',
                eligibleFor3rdNoticeLabel: 'Eligible for 3rd notice (days after 2st notice):',
                notice3StartDateLabel: 'Notice 3 Start Date',
                replyToEmailAddressLabel: 'Reply To Email Address (single address only)',
                logoFileNameLabel: 'Logo File Name',
                logoFileWidthLabel: 'Logo File Width',
                logoFileHeightLabel: 'Logo File Height',
                locationNameLabel: 'Location Name',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load letters settings. Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save letters settings. Please reload the page or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Letters settings updated successfully.',
            },
            locationConfig: {
                linkName: 'Location Config',
                locationIdLabel: 'Location Id',
                locationParentIdLabel: 'Location Parent Id',
                companyIdLabel: 'Company Id',
                nameLabel: 'Name',
                companyNameLabel: 'Company Name',
                databaseNameLabel: 'Database Name',
                timeZoneOffsetFromESTLabel: 'Time Zone Offset From EST',
                externallyActiveLabel: 'Externally Active',
                internallyActiveLabel: 'Internally Active',
                urlSegmentLabel: 'Url Segment',
                autoReportsFlagLabel: 'Auto Reports Flag',
                latLongLabel: 'Lat Long',
                permitsEnabledLabel: 'Permits Enabled',
                parkingEnabledLabel: 'Parking Enabled',
                eventsEnabledLabel: 'Events Enabled',
                rmvReleaseFormLabel: 'Rmv Release Form',
                includeOnPayVatsLabel: 'Include On Pay Vats',
                showAppealReasonsLabel: 'Show Appeal Reasons',
                requireCitationLabel: 'Require Citation',
                alertsAndNotificationsEnabledLabel: 'Alerts And Notifications Enabled',
                groupNameLabel: 'Group Name',
                displayOrderLabel: 'Display Order',
                permitInvoiceEnabledLabel: 'Permit Invoice Enabled',
                airplaneParkingLabel: 'Airplane Parking',
                currencyLabel: 'Currency',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load location settings. Location settings are only available to System Admins.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save location settings. Location settings are only available to System Admins.',
            },
            payments: {
                linkName: 'Payments',
                processorConfig: {
                    linkName: 'Payment Processor',
                    credentialsHeading: 'Credentials',
                    pageHeading: 'Processor Configuration',
                    processorLabel: 'Selected Processor',
                    webPaymentTransactionChargeLabel: 'Online Payment Fee',
                    useInternalAndWebTransactionChargeLabel: 'Apply Fee Internally',
                    five9EnabledLabel: 'Enable Five9',
                    credentialsUpdatedMessage: 'Credentials updated',
                    editCredentialsButton: 'Edit Credentials',
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load processor config settings.',
                    saveFailedTitle: 'Save Failed',
                    saveFailedMessage: 'Unable to save processor config settings.',
                    processorConfigSaved: 'Payment processor configuration saved',
                    paypal: {
                        dBLocationLabel: 'DB Location',
                        accountLabel: 'Account',
                        userLabel: 'User',
                        passwordLabel: 'Password',
                        partnerLabel: 'Partner',
                        loadFailedTitle: 'Load Failed',
                        loadFailedMessage: 'Unable to load Paypal credentials.',
                        saveFailedTitle: 'Save Failed',
                        saveFailedMessage: 'Unable to save Paypal credentials.',
                    },
                    vantiv: {
                        environmentLabel: 'Environment',
                        paypageIdLabel: 'Paypage ID',
                        merchantIdLabel: 'Merchant ID',
                        userLabel: 'User',
                        passwordLabel: 'Password',
                        loadFailedTitle: 'Load Failed',
                        loadFailedMessage: 'Unable to load Vantiv credentials.',
                        saveFailedTitle: 'Save Failed',
                        saveFailedMessage: 'Unable to save Vantiv credentials.',
                    },
                    e_xact: {
                        paymentTypeLabel: 'Payment Type',
                        cultureLabel: 'Culture',
                        internalUserLabel: 'Internal User',
                        pageIdLabel: 'Page Id',
                        transactionKeyLabel: 'Transaction Key',
                        responseKeyLabel: 'Response Key',
                        loadFailedTitle: 'Load Failed',
                        loadFailedMessage: 'Unable to load E-Xact credentials.',
                        saveFailedTitle: 'Save Failed',
                        saveFailedMessage: 'Unable to save E-Xact credentials.',
                    }
                },
                permitPayments: {
                    linkName: 'Permits',
                    permitSettingsMessageText: 'All permit related payment settings can be found on the',
                    permitSettingsLinkText: 'Permit Settings Page'
                },
                citationPayments: {
                    linkName: 'Citations',
                    payvatsMessagesHeader: 'PayVATS Messages',
                    onlinePaymentMessageLabel: 'Payment Completed Message',
                    transactionNotProcessedMessageLabel: 'Payment Failed Message',
                    scofflawPaymentsHeader: 'Scofflaw Payments',
                    blockScofflawOnlinePaymentsLabel: 'Prevent Scofflaw Online Payments?',
                    scofflawOnlinePaymentMessage: 'Scofflaw Online Payment Message',
                    feesAndDiscountsHeader: 'Fees And Discounts',
                    applyWebFeeInternallyLabel: 'Apply Online Fee Internally?',
                    webFeeLabel: 'Online Payment Fee',
                    onlineDiscountEnabledLabel: 'Online Payment Discount?',
                    onlineDiscountAmountLabel: 'Online Discount Amount',
                    internalDiscountEnabledLabel: 'Internal Payment Discount?',
                    internalDiscountAmountLabel: 'Discount Amount',
                    internalDiscountEligibleDaysLabel: 'Days Eligible For Discount',
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load citation payment settings.  ' +
                        'Please reload the page or contact support.',
                    saveFailedTitle: 'Save Failed',
                    saveFailedMessage: 'Unable to save citation payment settings.  ' +
                        'Please try again or contact support.',
                }
            },
            escalationManagement: {
                linkName: 'Escalation Management',
                citationEscalations: {
                    linkName: 'Citation Escalations',
                    heading: 'Citation Escalations Management',
                    daysBeforeEscalateLabel: 'Days Before Escalation',
                    daysBeforeEscalatePlaceholder: 'Days before escalation triggers',
                    escalationFixedValueLabel: 'Amount',
                    // escalationMultiplierLabel: 'Multiplier',
                    escalationStartDateLabel: 'Start Date',
                    escalationGroupIDLabel: 'Group ID',
                    escalationTypeLabel: 'Escalation Type',
                    // applyEscalationCapLabel: 'Cap Escalation Amount',
                    // maxCapAmountLabel: 'Escalation Max Cap',
                    // countDmvFeesTowardCapLabel: 'DMV Fees Count Toward Cap',
                    // escalateOnHoldReleaseLabel: 'Auto Escalate when Hold is Released',
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load escalation settings.  Please reload or contact support.',
                    saveFailedTitle: 'Save Failed',
                    saveFailedMessage: 'Unable to save escalation settings.  Please try again or contact support.',
                    onDeleteError: 'Uh-uh',
                    deleteFailedTitle: 'Delete Failed',
                    deleteFailedMessage: 'Unable to delete escalation.  Please try again or contact support.',
                },
                escalationGroup: {
                    linkName: 'Escalation Group',
                    heading: 'Escalation Group Management',
                    escalationGroupIDLabel: 'Group Description',
                    escalationTypeLabel: 'Escalation Type',
                    escalationFixedValueLabel: 'Amount',
                    escalationMultiplierLabel: 'Multiplier',
                    escalateOnHoldReleaseLabel: 'Auto Escalate',
                    applyEscalationCapLabel: 'Cap Escalation Amount',
                    maxCapAmountLabel: 'Max Cap Amount',
                    countDmvFeesTowardCapLabel: 'Add DMV Fees To Cap',
                    loadFailedTitle: 'Load Failed',
                    loadFailedMessage: 'Unable to load escalation settings.  Please reload or contact support.',
                    saveFailedTitle: 'Save Failed',
                    saveFailedMessage: 'Unable to save escalation settings.  Please try again or contact support.',
                    deleteFailedTitle: 'Delete Failed',
                    deleteFailedMessage: 'Unable to delete escalation.  Please try again or contact support.',
                },
            },
            handhelds: {
                chalkingTimeZones: {
                    descriptionLabel: 'Description',
                    timeLimitLabel: 'Time Limit',
                },
                linkName: 'Handhelds',
                innerLinkName: 'Handheld Features',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load handheld settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save handheld settings.  Please reload the page or contact support.',
                isOnStreetLabel: 'Is On Street Parking',
                enableChalkingLabel: 'Enable Chalking',
                defaultChalkingViolationLabel: 'Default Chalking Violation',
                chalkingHeading: 'Chalking',
                chalkingTimeZonesLabel: 'Chalking Time Zones',
                rollingWarningLabel: 'Rolling Warning',
                rollingWarningDaysLabel: 'Rolling Warning Days',
                vehicleModelRequiredLabel: 'Enable vehicle model selection',
                officerSignatureRequiredLabel: 'Require officer signature',
                vehicleVinRequiredLabel: 'Enable VIN entry',
                vehiclePlateExpirationRequiredLabel: 'Enable plate expiration selection',
                vehiclePlateColorRequiredLabel: 'Enable plate color selection',
                realtimePermitsLabel: 'Enable realtime permit checking',
                backOfficeVehicleLookupLabel: 'Enable back office vehicle lookup',
                meterMappingIntegrationLabel: 'Enable meter mapping',
                removeMinDaysEnabledLabel: 'Remove min days',
                duplicateCitationCheckLabel: 'Duplicate citation check',
                enableMobileBarcodeScanningLabel: 'Enable barcode scanning',
                enableOcrLabel: 'Enable LPR',
                recognizeVehicleLabel: 'Recognize vehicle during LPR',
                chalkingUsesBlockDropDownLabel: 'Chalking page uses dropdown list for block selection',
                genetecIntegrationLabel: 'Genetec Integration',
                brokenMeterEmailLabel: 'Broken Meter Email',
                emergencyAlertEmailsLabel: 'Emergency Alert Emails',
                ocrStateMapping: {
                    linkName: 'OCR State Map',
                    ocrLabel: 'OCR State',
                    vatsLabel: 'VATS State'
                },
                ocrVehicleMakeMapping: {
                    linkName: 'OCR Vehicle Make Map',
                    ocrLabel: 'OCR Make',
                    vatsLabel: 'VATS Make'
                },
                ocrVehicleColorMapping: {
                    linkName: 'OCR Color Map',
                    ocrLabel: 'OCR Color',
                    vatsLabel: 'VATS Color'
                },
            },
            hearings: {
                linkName: 'Hearings',
                gracePeriodLabel: 'Grace Period',
                noticeDaysLabel: 'Number of Days for Email Hearing Date Notice',
                emailSubjectLabel: 'Email Subject Text',
                emailBodyLabel: 'Email Body Text',
                reminderAutoSendLabel: 'Hearing Reminder Auto Send?',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load hearings settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save hearings settings.  Please try again or contact support.',
            },
            appeals: {
                linkName: 'Appeals',
                appealsAllowedLabel: 'Appeals Allowed',
                appealVatsMessageLabel: 'AppealVATS Message',
                hearingDateRequiredLabel: 'Automatically Appeal',
                numberOfDaysToFileLabel: 'Number of Days to File',
                adminEmailAddressLabel: 'Admin Email Address',
                gracePeriodLabel: 'Grace Period',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load appeals settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save appeals settings.  Please try again or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Appeals settings updated successfully.',
            },
            bagging: {
                linkName: 'Bagging',
                enableBaggingFlagLabel: 'Enable Bagging',
                baggingContactEmailLabel: 'Bagging Contact Email',
                baggingNotificationDaysLabel: 'Bagging Notification Days',
                baggingChargesLabel: 'Bagging Charges',
                baggingChargesCodeLabel: 'Code',
                baggingChargesDescriptionLabel: 'Description',
                baggingChargesFeeLabel: 'Daily Fee',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load bagging settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save bagging settings.  Please try again or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Bagging settings updated successfully.',
            },
            collections: {
                linkName: 'Collections',
                enabledLabel: 'Enabled',
                lastLetterLabel: 'Last Letter Before Collections Transfer',
                daysBeforeLabel: 'Days Before Collections Transfer',
                agencyEmailLabel: 'Collections Agency Email Address',
                addFeeLabel: 'Add Collections Fee%',
                ignoreLinkLabel: 'Ignore Customer Link?',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load collections settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save collections settings.  Please try again or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Collections settings updated successfully.',
            },
            lookups: {
                linkName: 'Lookups',
                lookupsHeading: 'Lookups',
                inStateLookupsLinkName: 'In State Lookups',
                outOfStateLookupsLinkName: 'Out Of State Lookups',
                lookupsStartDateLabel: 'Start Date (oldest citation date)',
                autoGenInStateLookupFlagLabel: 'Auto Generate Lookups?',
                inStateLabel: 'IN-STATE',
                instateLookupFrequencyLabel: 'Frequency',
                homeStateLabel: 'Home State',
                inStateLookupFilenameFormatLabel: 'File Name Format (ex. XXXXyymmdd.txt)',
                inStateLookupTransferTypeLabel: 'Tranfers Type',
                inStateLookupEmailAddressLabel: 'Email Address',
                inStateLookupFTPAddressLabel: 'FTP Address',
                inStateUpLoadFilenameLabel: 'Upload File Name',
                inStateDownLoadFilenameLabel: 'download File Name',
                inStateLookupFTPDestFolderLabel: 'FTP Destination Folder',
                inStateLookupFTPUserNameLabel: 'FTP User Name',
                inStateLookupFTPPasswordLabel: 'FTP Password',
                inStateLookupFTPPasswordConfirmLabel: 'Confirm FTP Password',
                inStateEncryptionKeyLabel: 'Zip Encryption Key',
                inStateLookupNextRunDateLabel: 'Next In-State Run Date',
                inStateLookupLastRunDateLabel: 'Last In-State Run Date',
                inStateStartDateLabel: 'In-State Start Date',
                outOfStateLabel: 'OUT-OF-STATE',
                autoGenOOSLookupFlagLabel: 'Auto Generate Lookups?',
                oosLookupFilenameFormatLabel: 'File Name Format (ex. XXXXyymmdd.txt)',
                oosLookupTransferTypeLabel: 'Tranfers Type',
                oosLookupEmailAddressLabel: 'Email Address',
                oosLookupFTPAddressLabel: 'FTP Address',
                oosLookupFTPDestFolderLabel: 'FTP Destination Folder',
                oosLookupFTPUserNameLabel: 'FTP User Name',
                oosLookupFTPPasswordLabel: 'FTP Password',
                oosLookupNextRunDateLabel: 'Next Out-Of-State Run Date',
                oosEncryptionKeyLabel: 'Encryption Key',
                oosLookupFTPPasswordConfirmLabel: 'Confirm Password',
                dmvExportLabelLabel: 'DMV EXPORT',
                caDMVUserCodeLabel: 'CA DMV User Code',
                fTPPassiveLabel: 'Use Passive FTP?',
                fTPSSLLabel: 'Use SSL? ',
                sslPortNumberLabel: 'SSL Port Number',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load lookups settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save lookups settings.  Please try again or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Lookups settings updated successfully.',
            },
            reports: {
                linkName: 'Reports',
                fiscalYearLabel: 'Fiscal Year Start Date',
                autoGenDCRLabel: 'Auto Gen DCR',
                dcrEmailAddressesLabel: 'DCR Email Address(es)',
                loadFailedTitle: 'Load Failed',
                loadFailedMessage: 'Unable to load reports settings.  Please reload the page or contact support.',
                saveFailedTitle: 'Save Failed',
                saveFailedMessage: 'Unable to save reports settings.  Please try again or contact support.',
                saveSuccessTitle: 'Save Successful',
                saveSuccessMessage: 'Reports settings updated successfully.',
            }
        },
        myReportsManagement: {
            reportsLabel: 'Reports for user {userName} at location {currentLocation}',
            multiselectPlaceholder: 'Select report(s)',
            multiselectSelectionLabel: '{numReports} report(s) selected'
        },
        diagnosticCounts: {
            countDate: 'Count Date',
            lookupsCnt: 'Lookups',
            citationsCnt: 'Citations',
            paymentsCnt: 'Payments',
            escalationsCnt: 'Escalations',
            lettersCnt: 'Letters',
            emailsCnt: 'Emails',
            refreshDiagnosticError: 'Error retrieving diagnostic counts',
        },
        tableManagement: {
            heading: 'Table Management',
            recID: 'RecID',
            code: 'Code',
            description: 'Description',
            order: 'Order',
            deleteConfirmMessage: 'Are you sure you want to delete record {recID}?',
            deleteItemError: 'Error deleting item',
            errorInMethodX: 'Error in method {x}'
        },
        vendorLotIds: {
            vendorLabel: 'Vendor',
            selectVendorMessage: 'Select a vendor to view their lot ids',
            lotIdLabel: 'Lot',
            vendorLotIdLabel: 'Vendor Lot ID',
            loadFailedTitle: 'Load Failed',
            loadFailedMessage: 'Unable to load Vendor Lot Ids',
            saveFailedTitle: 'Save Failed',
            saveFailedMessage: 'Attempt to save changes failed',
            filterByLabel: 'Filter By',
            filterByLotLabel: 'Lot ID',
            filterByVendorLabel: 'Vendor Lot',
        },
        localizationOverrides: {
            languageHeader: 'Language',
            overridesOnly: 'Overrides Only',
            showAllValues: 'Show All Values',
            loadFailedTitle: 'Unable to load overrides',
            loadFailedMessage: 'Load failed',
            saveFailedMessage: 'Unable to save override',
            saveFailedTitle: 'Save failed',
            explanationText: 'Search for the text you wish to override at this location.',
            explanationBracesWarning: 'Text inside {braces} should not be touched; it will be replaced by other text when the page is displayed.',
            allLanguagesOverriddenMessage: 'No languages to override',
            noOverridesMessage: 'No languages have been overridden at this location',
        },
        behaviorProfile: {
            nameLabel: 'Name',
            lettersEnabledLabel: 'Letters Enabled?',
            collectionsEnabledLabel: 'Collections Enabled?',
            selectedTicketTemplateLabel: 'Selected Ticket Template',
            escalationGroupLabel: 'Escalation Group',
            loadFailedTitle: 'Load failed',
            loadFailedMessage: 'Unable to load profiles',
            saveFailedTitle: 'Save failed',
            saveFailedMessage: 'Unable to save profile changes',
            deleteFailedTitle: 'Delete failed',
            deleteFailedMessage: 'Unable to delete profile',
            fineRevenueTypeLabel: 'Fine Revenue Type',
            escalationRevenueTypeLabel: 'Escalation Revenue Type',
            isHonorRevenueLabel: '(Impark only) Honor Revenue?',
            profileInUseMessage: 'This profile is in use and cannot be deleted.  Make sure no violation codes or lots are using this profile and try deleting it again'
        },
        revenue: {
            revenueHeader: 'Revenue Types',
            taxHeader: 'Taxes',
            revenueTypes: {
                nameHeader: 'Name',
                applicableTaxesHeader: 'Applicable Taxes',
                loadFailedTitle: 'Load failed',
                loadFailedMessage: 'Unable to load revenue types',
                saveFailedTitle: 'Save failed',
                saveFailedMessage: 'Unable to save revenue type changes',
                deleteFailedTitle: 'Delete failed',
                deleteFailedMessage: 'Unable to delete revenue type',
            },
            taxes: {
                nameHeader: 'Name',
                rateHeader: 'Rate',
                loadFailedTitle: 'Load failed',
                loadFailedMessage: 'Unable to load taxes',
                saveFailedTitle: 'Save failed',
                saveFailedMessage: 'Unable to save changes',
                deleteFailedTitle: 'Delete failed',
                deleteFailedMessage: 'Unable to delete tax',
                taxInUseMessage: 'At least one revenue type incurs this tax, so it cannot be deleted'
            }
        },
        ticketTemplate: {
            nameHeader: 'Name',
            templateTextHeader: 'Template Text',
            deleteFailedTitle: 'Delete failed',
            templateInUseMessage: 'This ticket template is in use and cannot be deleted.  Make sure no behavior profiles are using this template and then try again',
            templateBuilderLinkName: 'Template Builder',
        },
        ticketTemplateBuilder: {
            commandToken: {
                commands: {
                    alignmentLabel: 'Alignment',
                    selectLineFeedSizeLabel: 'Feed Size',
                    setFontLabel: 'Font Size',
                    lineCountLabel: 'Line Count',
                    leftMargin: 'Left Margin',
                    rightMargin: 'Right Margin',
                    tabColumnsLabel: 'Tab Columns',
                    pageLinesLabel: 'Page Length in Lines',
                    imageUploadLabel: 'Image',
                    imageUploadPlaceholder: 'Upload Image',
                    heightPlaceholder: 'Height',
                    widthPlaceholder: 'Width',
                    uploadButton: 'Upload'
                }
            },
            literalToken: {
                textLabel: 'Text',
            },
            instructionsHeader: 'Add, edit, or remove template elements below',
            addNewTokenAtStartLabel: 'Insert at Top',
            addNewTokenBelowLabel: 'Insert Below',
            addNewTextLiteralLabel: 'Insert Text',
            addNewVariableLabel: 'Insert Variable',
            addNewCommandLabel: 'Insert Command',
            saveFailedTitle: 'Save Failed',
            saveFailedMessage: 'Unable to save; please try again or contact support',
            unfinishedCommandTitle: 'Error',
            unfinishedCommandMessage: 'At least one command token has not been finished.  Please select a command type for it and fill out any fields.',
        },
    },
    permit: {
    },
    citation: {
        root: {
            searchPlaceholder: 'Search for Citations',
            advancedSearch: 'Advanced Search'
        },
        search: {
            citationNumberLabel: 'Citation #',
            lotLabel: 'Lot',
            officerLabel: 'Officer',
            violationLabel: 'Violation',
            startDateLabel: 'Start Date',
            endDateLabel: 'End Date',
            plateNumberLabel: 'Plate Number',
            exactPlateLabel: 'Exact Plate',
            vehicleStateLabel: 'Vehicle State',
            driversLicenseLabel: 'Drivers License',
            vinLabel: 'VIN',
            firstNameLabel: 'First Name',
            lastNameLabel: 'Last Name',
            middleNameLabel: 'Middle Name',
            addressLabel: 'Address',
            suiteAptNumberLabel: 'Suite/Apt No',
            cityLabel: 'City',
            stateLabel: 'State',
            zipLabel: 'Zip',
            homePhoneLabel: 'Home Phone',
            workPhoneLabel: 'Work Phone',
            cellPhoneLabel: 'Cell Phone',
            emailLabel: 'Email Label',
            badAddressLabel: 'Bad Address',
            unpaidOnlyLabel: 'Unpaid Only',
            commentsOnlyLabel: 'Comments Only',
            photosOnlyLabel: 'Photos Only',
            results: {
                citationIdHeader: 'Citation ID',
                citationDateHeader: 'Citation Date',
                officerHeader: 'Officer',
                lastNameHeader: 'Last Name',
                middleNameHeader: 'Middle Name',
                firstNameHeader: 'First Name',
                plateStateHeader: 'Plate State',
                plateNumberHeader: 'Plate Nbr',
                driversLicenseHeader: 'Driver\'s License',
                plateTypeHeader: 'Plate Type',
                vehicleMakeHeader: 'Make',
                vehicleColorHeader: 'Color',
                dmvHoldHeader: 'DMV Hold',
                voidHeader: 'Void',
                remainingBalanceHeader: 'Unpaid Balance',
                datePaidHeader: 'Date Paid',
                lotNameHeader: 'Location',
                spaceHeader: 'Space',
                blockHeader: 'Block',
                bootTowHeader: 'Boot Tow',
                inactiveHeader: 'Inactive',
                violationHeader: 'Violation',
                citationNotesHeader: 'Citation Notes',
                customerNotesHeader: 'Customer Notes',
                firstNoticeDateHeader: '1st Notice Date',
                secondNoticeDateHeader: '2nd Notice Date',
                scofflawNoticeDateHeader: 'Scofflaw Notice Date',
                editLinkText: 'Edit',
                appealLinkText: 'Appeal',
                paymentLinkText: 'Payment',
                payvatsLinkText: 'PayVATS',
                hearingHighlightDescription: 'Highlighted rows have a hearing scheduled',
                sentToCourtHighlightDescription: 'Highlighted rows are sent to court',
                underAppealHighlightDescription: 'Highlighted rows are under appeal',
                onHoldHighlightDescription: 'Highlighted rows are on hold',
                sentToCollectionsHighlightDescription: 'Highlighted rows are sent to collections',
                writeOffHighlightDescription: 'Highlighted rows are write offs',
                scofflawEligibleHighlightDescription: 'Highlighted rows are scofflaw eligible',
                noResults: 'No results found',
                resultsExcelFileName: 'CitationSearchResults',
                defaultSearchError: 'Error while searching'
            }
        },
        issueTicket: {
            issueTicketLabel: 'Issue Ticket',
            citationNumberLabel: 'Citation Number',
            issueDateLabel: 'Date',
            issueTimeLabel: 'Time',
            issueDateAndTimeLabel: 'Date and Time',
            locationLabel: 'Location Details',
            vehicleLabel: 'Vehicle Details',
            plateLabel: 'Plate Information',
            violationLabel: 'Violation Details',
            officerLabel: 'Issuing Officer',
            lotLabel: 'Location',
            blockLabel: 'Block Number',
            spaceLabel: 'Space',
            vehicleMakeLabel: 'Select Make',
            vehicleTypeLabel: 'Select Type',
            vehicleColorLabel: 'Select Color',
            plateTypeLabel: 'Plate Type',
            violationCodeLabel: 'Violation Code',
            plateStateLabel: 'Plate State',
            commentLabel: 'Comment',
            plateNumberLabel: 'Plate Number',
            stackedPlateNumberLabel: 'Stacked Plate',
            plateAndStackedLabel: 'Plate Number - Stacked Plate',
            vinLabel: 'VIN',
            plateExpirationDateLabel: 'Plate Expiration Date',
            plateExpirationMonthLabel: 'Plate Expiration Month',
            plateExpirationYearLabel: 'Year',
            loadFailedTitle: '',
            loadFailedMessage: '',
            saveFailedTitle: 'Save Failed',
            saveFailedMessage: 'Unable to save ticket.  Please try again or contact support.',
            saveSuccessTitle: 'Save Successful',
            saveSuccessMessage: 'Ticket saved successfully.',
        }
    },
    releaseNotes: {
        heading: 'Release Notes Management',
        noteDescriptionField: 'Note Description',
        noteDescriptionFieldPlaceholder: 'Description...',
        shortFormField: 'Short Form',
        longFormField: 'Long Form'
    },
    message: {
        helloWorld: 'hello, world: internationalization is set up'
    },
    login: {
        userNameLabel: 'User Name',
        passwordLabel: 'Password',
        submitText: 'Login',
        loginFailedTitle: 'Login Failed',
        loginFailedMessage: 'Invalid username or password; please try again',
        forgotPasswordText: 'Forgot password?',
        mustResetPassword: 'You must reset your password',
        loginForbiddenTitle: 'Login Forbidden',
        loginForbiddenMessage: 'The account is locked.',
        tooManyRequestsTitle: 'Too many requests'
    },
    passwordResetRequest: {
        userNameLabel: 'User Name',
        submitText: 'Reset Password',
        requestSuccessMessage: 'A password reset link has been sent to the email address on file for the user',
        requestSuccessTitle: 'Reset Requested',
        requestFailedMessage: 'An unknown error has occurred',
        requestFailedTitle: 'Request Failed',
        resetPasswordHeading: 'Request Password Reset'
    },
    passwordResetCompletion: {
        resetPasswordHeading: 'Reset Password',
        newPasswordLabel: 'New Password',
        newPasswordConfirmLabel: 'Confirm New Password',
        userNameLabel: 'User Name',
        submitText: 'Reset Password',
        requestSuccessMessage: 'Your password has been successfully reset. Redirecting you back to the login page.',
        requestSuccessTitle: 'Password Reset Successfully',
        requestFailedMessage: 'Error resetting password',
        requestFailedTitle: 'Password Reset Failed',
        retryMessage: 'Your password reset did not go through. The link you used is most likely expired. Please try a new password reset.',
        tryAgain: 'Email me a new link'
    },
    currency: {
        style: 'currency',
        currency: 'USD'
    },
    reporting: {
        root: {
            heading: 'Reporting',
        },
        reportingGenerator: {
            heading: 'Reporting Hub',
            reports: 'Reports',
            categories: 'Categories',
            startDate: 'Start Date',
            endDate: 'End Date',
            reportType: 'Report Type',
            runReport: 'Run Report'
        },
    },
};

// https://stackoverflow.com/a/51365037/1185316
type RecursivePartial<T> = {
    [P in keyof T]?:
    T[P] extends Array<(infer U)> ? Array<RecursivePartial<U>> :
    T[P] extends object ? RecursivePartial<T[P]> :
    T[P];
};
export type LocalizationMessages = RecursivePartial<typeof EN_US>;

export default EN_US;
